/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService
 */
import * as References from './TemplateInstantiationService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#instantiateTemplate
 */
export const INSTANTIATE_TEMPLATE_MUTATION_FIELD_NAME =
  'com_hubspot_automation_templatesrpc_TemplateInstantiationService_instantiateTemplate';
export const INSTANTIATE_TEMPLATE_MUTATION: RegisteredQuery<
  'result',
  References.InstantiateTemplateRequestType,
  References.InstantiateTemplateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: INSTANTIATE_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId', 'targetType', 'assetBindings'],
  fetcher(
    request: References.InstantiateTemplateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.InstantiateTemplateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.instantiateTemplateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#getInstantiationStatus
 */
export const GET_INSTANTIATION_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_automation_templatesrpc_TemplateInstantiationService_getInstantiationStatus';
export const GET_INSTANTIATION_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetInstantiationStatusRequestType,
  References.GetInstantiationStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTANTIATION_STATUS_QUERY_FIELD_NAME,
  args: ['taskId'],
  fetcher(
    request: References.GetInstantiationStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstantiationStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstantiationStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#listInstantiationRequests
 */
export const LIST_INSTANTIATION_REQUESTS_QUERY_FIELD_NAME =
  'com_hubspot_automation_templatesrpc_TemplateInstantiationService_listInstantiationRequests';
export const LIST_INSTANTIATION_REQUESTS_QUERY: RegisteredQuery<
  'result',
  References.ListInstantiationRequestsRequestType,
  References.ListInstantiationRequestsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_INSTANTIATION_REQUESTS_QUERY_FIELD_NAME,
  args: [
    'templateId',
    'offset',
    'filterByUserId',
    'statusFilter',
    'pageLength',
  ],
  fetcher(
    request: References.ListInstantiationRequestsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListInstantiationRequestsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listInstantiationRequestsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService#listWorkflowsForTemplate
 */
export const LIST_WORKFLOWS_FOR_TEMPLATE_QUERY_FIELD_NAME =
  'com_hubspot_automation_templatesrpc_TemplateInstantiationService_listWorkflowsForTemplate';
export const LIST_WORKFLOWS_FOR_TEMPLATE_QUERY: RegisteredQuery<
  'result',
  References.ListWorkflowsForTemplateRequestType,
  References.ListWorkflowsForTemplateResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_WORKFLOWS_FOR_TEMPLATE_QUERY_FIELD_NAME,
  args: ['templateId', 'offset', 'pageLength'],
  fetcher(
    request: References.ListWorkflowsForTemplateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListWorkflowsForTemplateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listWorkflowsForTemplateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
